import { useQuery } from 'react-query';

import { useAppContext } from '../contexts/AppContext';
import { CURRENT_USER_KEY, User, getCurrentUser } from '../utils/backend-api/currentUser';

export function buildUser(user?: User): User {
  if (!user) return undefined;
  return {
    ...user,
    can_view_forum_posts: true,
  };
}

// default retries is 3, but in cases where we expect 401s, don't keep retrying
export default function useCurrentUser(retry: number | boolean = 3) {
  const { initialCurrentUser } = useAppContext();
  const { data, isLoading } = useQuery<User>(CURRENT_USER_KEY, () => getCurrentUser(), {
    initialData: initialCurrentUser,
    retry,
  });

  return { currentUser: buildUser(data), isLoadingCurrentUser: isLoading };
}
